enum DateRange {
  ALL_TIME = "ALL_TIME",
  PAST_YEAR = "PAST_YEAR",
  PAST_3_MONTHS = "PAST_3_MONTHS",
  PAST_MONTH = "PAST_MONTH",
  PAST_14_DAYS = "PAST_14_DAYS",
}

export default DateRange;
